export const comments_3750244 = {"data":{"data":[],"links":{}}}